import {jsText} from "../include/jsText";
import {ReadMoreFilterButton} from "./readMoreFilterButton";
import {Url} from "./Url.js";

let currentPage = 1,
    isPaginating = false,
    pagesAmount;

$(function () {
    window.$QuickSelectionAutoForm = $('#QuickSelectionAutoForm');
});

window.QuickSelectionAutoFormResultSelector = '#filter-results';
window.QuickSelectionAutoFormSendFilter = function () {

    currentPage = 1;

    $("#filter-results").hide();
    $("#filter-results tbody").html("");
    $("#show-more-filter-results").hide();
    $("#filter_loader").show();

    let data = $QuickSelectionAutoForm.serializeArray();
    data.push({name: $QuickSelectionAutoForm.attr('id') + '[page]', value: 1});

    $.ajax({
        url: Url.to($QuickSelectionAutoForm.attr('action')),
        type: 'post',
        data: data,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('Accept', '*/*;q=0.5, text/javascript, application/javascript, application/ecmascript, application/x-ecmascript');
        },
        error: function (e) {
            console.log(e);
        }
    }).then(function (response) {

        pagesAmount = response.pagesAmount;
        $(QuickSelectionAutoFormResultSelector).html(response.html);
        $("#filter_loader").hide();
        $("#filter-results").show();
        if (currentPage < pagesAmount) $("#show-more-filter-results").show();
        afterLoad();
    });
};

function afterLoad() { //#ND
    if (window.initEasyPieChart) {
        window.initEasyPieChart(window.QuickSelectionAutoFormResultSelector);
    }
    if (window.initSlider) {
        window.initSlider(window.QuickSelectionAutoFormResultSelector);
    }
    jsText();
}

export function prepareSearchFilter() {
    new ReadMoreFilterButton('.used-filter .row-select');
    window.QuickSelectionAutoFormResultSelector = '#filter-results';

    var elements = ["#quickselectionautoform-country", "#filter_engine", "#filter_transmission", "#filter_drive", "#filter_type"];
    $.each(elements, function( index, value ) {
      var elem = $(value);
      if ($(elem) && $(elem).val() != '' && $(elem).val() != 0)
      {
       //$(".show-more.open").show();
       
       $(".show-more.close").trigger('click');
       return false;
      }
    });    
  
    


    $('.btn-submit', $QuickSelectionAutoForm).on('click', function () {
        $('#filter_price_max, #filter_price_min').each(function() {
            $(this).val( $(this).val().replaceAll(' ', '') );
        }); 
        
        $("#QuickSelectionAutoForm").submit();
        return false;
        //window.QuickSelectionAutoFormSendFilter();
    });
    $QuickSelectionAutoForm.on('keypress', 'select, input', function (e) {
        if (e.charCode === 13) {
            e.preventDefault();
            $(e.target).change();
        }
    });
    $("#show-more-filter-results").on('click', function () {
        $(this).hide();
        if (!isPaginating && currentPage < pagesAmount) {
            currentPage++;
            isPaginating = true;

            let data = $QuickSelectionAutoForm.serializeArray();
            data.push({name: $QuickSelectionAutoForm.attr('id') + '[page]', value: currentPage});

            $("#filter_loader").show();
            $.ajax({
                url: Url.to($QuickSelectionAutoForm.attr('action')),
                type: 'post',
                data: data,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Accept', '*/*;q=0.5, text/javascript, application/javascript, application/ecmascript, application/x-ecmascript');
                },
                error: function (e) {
                    console.log(e);
                }
            }).then(function (response) {
                isPaginating = false;
                $("#filter_loader").hide();
                pagesAmount = response.pagesAmount;
                $(window.QuickSelectionAutoFormResultSelector).append(response.html);
                if (currentPage < pagesAmount) $("#show-more-filter-results").show();
                afterLoad();
            });
        }
    });
    $("[data-action=filter-reset]").on('click', function (e) {
        e.preventDefault();
        $(this).closest('form')[0].reset();
    });

    let $filterModel = $('#filter_model');
    let filterModelStartHtml = $filterModel.html();
    $('#filter_brand').on('change', function () {
    
    var selectedValue = $('option:selected', this).val();
    
    var newHtml = '<option value="0">Модель</option>';
    
    if (selectedValue > 0)
    {
      for (var key in ModelsSelectData) {
          var option = ModelsSelectData[key];
          if (selectedValue == option.brand_id)
          {
           newHtml += '<option value="'+option.name+'">'+option.name+'</option>'; 
          }
      }
    }
    console.log(selectedValue);
    console.log(newHtml);
    $filterModel.html(newHtml);

        /*
        let value = $('option:selected', this).val();
        if(value) {
            let data = $QuickSelectionAutoForm.serializeArray();
            data.push({name: $QuickSelectionAutoForm.attr('id') + '[page]', value: 1});
            data.push({name: 'getModels', value: true});

            $.post({
                url: $QuickSelectionAutoForm.attr('action'),
                data: data
            }).then(function (response) {
                $filterModel.html(response.modelsSelectHtml);
            })
        } else {
            $filterModel.html(filterModelStartHtml);
        }
        */
    });
    
    //onload
    $('#filter_brand').trigger('change');
    if ($("#filter_model_value").val() != '')
    {
     $("#filter_model").val( $("#filter_model_value").val() );
     $('#filter_model').next().html( $("#filter_model_value").val() );
    
    }
    
}

